const getSiteId = (rootState) => rootState.ws.site.id;

export default getSiteId;
